import { z } from 'zod';
import { ParsingDataError } from '@/src/shared/errors';

export function safeParseZodObject<T>(schema: z.ZodType<T>, input: T) {
  const result = schema.safeParse(input);
  if (!result.success) {
    console.error(result.error.issues);
    throw new ParsingDataError();
  }

  return result.data;
}

export function toFormData(
  data: any,
  formData = new FormData(),
  parentKey = ''
): FormData {
  if (data === null || data === undefined) {
    return formData;
  }

  // File
  if (data instanceof File) {
    formData.append(parentKey, data);
    return formData;
  }

  // Array
  if (Array.isArray(data)) {
    data.forEach((value, index) => {
      toFormData(value, formData, `${parentKey}[${index}]`);
    });

    return formData;
  }

  // Object
  if (typeof data === 'object') {
    Object.entries(data).forEach(([key, value]) => {
      const formKey = parentKey ? `${parentKey}[${key}]` : key;

      toFormData(value, formData, formKey);
    });

    return formData;
  }

  // Primitive
  formData.append(parentKey, String(data));

  return formData;
}
